import React from "react";
import APIService from "../../Service/APIService";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import { Button, Modal, Select, Col, Form, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import TitleBar from "../../common/title-bar/title-bar.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";

const DistributorAccount = (props) => {
  const { user } = useAuth();
  const { distributorData } = props;
  const [accounts, setAccounts] = React.useState([]);
  const [userType, setUserType] = React.useState("");
  const accountsRequestIdRef = React.useRef(0);

  React.useEffect(() => {
    const userData = user;
    if (userData?.Type === "Distributor") {
      if (userData?.IsManager === true) {
        setUserType("Manager");
      } else {
        setUserType("User");
      }
    } else {
      setUserType(userData?.Type || "");
    }
  }, [user]);

  React.useEffect(() => {
    getAccountOptions();
  }, []);

  React.useEffect(() => {
    const distributorID = distributorData?.ID;
    if (!distributorID) {
      setAccounts([]);
      return;
    }

    const currentRequestId = accountsRequestIdRef.current + 1;
    accountsRequestIdRef.current = currentRequestId;
    let isCancelled = false;

    const getAccountsFromDistributor = async () => {
      try {
        const apiServe = new APIService();
        const response = await apiServe.getDataFromBackend(
          `getaccountsfromdistributor?ID=${distributorID}`
        );
        console.log("Accounts from Distributors: ", response?.data?.data);
        const mappedAccounts = (response?.data?.data || []).map((account) => {
          return {
            ...account,
            DistributorName: distributorData?.DistributorName,
            DistributorID: distributorID,
          };
        });

        if (
          !isCancelled &&
          accountsRequestIdRef.current === currentRequestId
        ) {
          setAccounts(mappedAccounts);
        }
      } catch (error) {
        console.error(
          "[DistributorAccount] Failed to fetch accounts from distributor",
          error
        );
        if (
          !isCancelled &&
          accountsRequestIdRef.current === currentRequestId
        ) {
          setAccounts([]);
        }
      }
    };

    setAccounts([]);
    getAccountsFromDistributor();

    return () => {
      isCancelled = true;
    };
  }, [distributorData?.DistributorName, distributorData?.ID]);

  const [accountOptions, setAccountOptions] = React.useState([]);
  const [selectedAccount, setSelectedAccount] = React.useState(null);

  const getAccountOptions = async () => {
    // get all accounts from db
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getaccounts`);
    const tempAcc = response?.data?.data;
    const tempAccountOptions = [];
    tempAcc.forEach((element) => {
      tempAccountOptions.push({
        value: element.ID,
        label: element.AccountName,
      });
    });
    setAccountOptions(tempAccountOptions);
  };

  const submitAccount = async () => {
    if (selectedAccount && distributorData) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to add this account to the distributor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: colors["successColor"],
        cancelButtonColor: colors["failureColor"],
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const apiServe = new APIService();
          const response = await apiServe.addDataToBackend(
            {
              AccountID: selectedAccount,
              DistributorID: Number(distributorData.ID),
            },
            "updateaccount?type=AddDistributor"
          );
          console.log("Update Account Response: ", response);
          Swal.fire("Added!", "The account has been added.", "success").then(
            () => {
              window.location.reload();
            }
          );
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select an account!",
      });
    }
  };

  const [modalChildVisible, setModalChildVisible] = React.useState(false);
  const handleModalOk = () => {
    setModalChildVisible(false);
  };
  const handleModalCancel = () => {
    setModalChildVisible(false);
  };
  const handleChildNew = () => {
    setModalChildVisible(true);
  };
  console.log(accounts, "accounts >>>>>>>>1");
  const addAccountButton =
    (userType === "Admin" || userType === "Authorizer") && hasPermission(user, "manage_distributors.edit") ? (
      <Button
        type="primary"
        icon={<PlusOutlined />}
        style={{ background: colors["primaryColor"] }}
        onClick={handleChildNew}
      >
        Add Account
      </Button>
    ) : null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <TitleBar label="Accounts" rightFilterBarComponents={addAccountButton} />
      {accounts && userType && (
        <>
          <GenericDashboard
            data={accounts}
            screen="DistributorAccount"
            userType={userType}
          />
        </>
      )}

      {/* <div style={{ marginTop: 16 }}>
        <Button
          ghost
          style={{ marginRight: 8, color: "#444", borderColor: "#444" }}
        >
          Show More
        </Button>
        <Button ghost style={{ color: "#444", borderColor: "#444" }}>
          Show All
        </Button>
      </div> */}
      <Modal
        title="Add Account"
        open={modalChildVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        centered={true}
        footer={null}
        style={{ width: "800px" }}
      >
        <div style={{ padding: "10px 20px 20px 20px" }}>
          {/* <h3>Add Account</h3> */}
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={18}>
                <Form.Item label="Account Name">
                  <Select
                    defaultValue="Choose Account"
                    onChange={(value) => setSelectedAccount(value)}
                    options={accountOptions}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Button
              type="primary"
              style={{ background: "#27a907" }}
              onClick={submitAccount}
            >
              Add Account
            </Button>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default DistributorAccount;
